import React from 'react';
import { FormRequestActions } from '../actions/formRequestActions';

export const MFTrackView = ({ track, title, isChecked = true, isReadOnly = false }) => {
    const trackOnChange = (e) => {
        FormRequestActions.trackSelectChanged(e.target.name, e.target.checked);
    };

    return (
        <span title={title ?? "Track name is no longer valid for selected MPs"}>
            <div style={{ backgroundColor: 'red' }}>
                <input
                    type="checkbox"
                    checked={isChecked}
                    name={track.name}
                    onChange={trackOnChange}
                    id={track.name.replace(/ /g, '')}
                    disabled={isReadOnly}
                />
                {track.name}
            </div>
        </span>
    );
};
